import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class cxdsdwe24232Service {

  private wasm: any;
  private xdew4353l4m: string | null = null;

  async w323wetKsdsewe(): Promise<string> {
    if (this.xdew4353l4m) return this.xdew4353l4m;

    if (!this.wasm) {
      this.wasm = await this.loadWasm();
    }

    const resultPtr = this.wasm._buildKey();
    this.xdew4353l4m = this.wasm.UTF8ToString(resultPtr);

    return this.xdew4353l4m;
  }

  private async loadWasm(): Promise<any> {
    try {
      const response = await fetch('assets/wasm/key-builder.wasm');
      
      if (!response.ok) {
        throw new Error(`Failed to fetch WASM: ${response.status} ${response.statusText}`);
      }
      
      const wasmBuffer = await response.arrayBuffer();
      
      const wasmInstance = await WebAssembly.instantiate(wasmBuffer, {
        a: {
          a: () => {
            return 0;
          }
        }
      });

      const memory = wasmInstance.instance.exports.b as WebAssembly.Memory;
      const buildKeyFunc = wasmInstance.instance.exports.d as Function;
      const mallocFunc = wasmInstance.instance.exports.e as Function;
      const freeFunc = wasmInstance.instance.exports.f as Function;
      
      const module = {
        _buildKey: buildKeyFunc,
        _malloc: mallocFunc,
        _free: freeFunc,
        
        UTF8ToString: (ptr: number) => {
          if (!ptr) return '';
          
          const HEAPU8 = new Uint8Array(memory.buffer);
          const decoder = new TextDecoder('utf-8');
          
          let end = ptr;
          while (HEAPU8[end] !== 0 && end < memory.buffer.byteLength) {
            end++;
          }
          
          return decoder.decode(HEAPU8.slice(ptr, end));
        },
        
        allocateUTF8: (str: string) => {
          const encoder = new TextEncoder();
          const encoded = encoder.encode(str + '\0'); // Add null terminator
          
          const ptr = mallocFunc(encoded.length);
          const HEAPU8 = new Uint8Array(memory.buffer);
          HEAPU8.set(encoded, ptr);
          
          return ptr;
        }
      };

      return module;
      
    } catch (error) {
      console.error('Failed to load WASM module:', error);
      throw error;
    }
  }
}